import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class RegistroAnalisisCalador {
  static altaAnalisis (numero, analisis) {
    console.log('analisis:', analisis)
    const axios = getAxiosInstance()
    const promise = axios.post(`registro_analisis_calador`,
      `{"valores": {"numero": "${numero}" , "analisis_calador": ${JSON.stringify(analisis).toString()} }}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default RegistroAnalisisCalador
